import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import "./index.scss";
import { DelecteIcon } from "../../assets/icons/DelecteIcon";

export default function CartItem({ product, onRemove, onQuantityChange }) {
  const [error, setError] = useState("");

  const handleQuantityChange = (e) => {
    let newQty = parseInt(e.target.value, 10);

    if (isNaN(newQty) || newQty < 1) {
      newQty = 1;
      setError("");
    } else if (newQty > product.quantite) {
      newQty = product.quantite;
      setError(`La quantité maximale disponible est ${product.quantite}`);
    } else {
      setError("");
    }

    onQuantityChange(product._id, newQty);
  };

  return (
    <>
      {/* 🖥️ Version desktop */}
      <Row className="cart-item align-items-center py-2 border-bottom d-none d-md-flex">
        {/* Produit */}
        <Col md={6} className="d-flex align-items-center">
          <img
            src={product.image}
            alt={product.title}
            className="product-img me-2"
          />
          <div>
            <h6>{product.title}</h6>
            <small>{product.ref}</small>
          </div>
        </Col>

        {/* Prix unitaire */}
        <Col md={2}>{Number(product.price).toFixed(3)} dt</Col>

        {/* Quantité */}
        <Col md={2}>
          <input
            type="number"
            min="1"
            max={product.quantite}
            value={product.quantity}
            className="form-control qty-input"
            onChange={handleQuantityChange}
          />
          {error && <div className="error1 mt-1">{error}</div>}
        </Col>

        {/* Total + bouton supprimer */}
        <Col
          md={2}
          className="d-flex justify-content-between align-items-center">
          {(product.price * product.quantity).toFixed(3)} dt
          <Button
            variant="link"
            className="text-danger p-0 ms-2"
            onClick={() => onRemove(product._id)}>
            <DelecteIcon />
          </Button>
        </Col>
      </Row>

      {/* 📱 Version mobile */}
      <div className="cart-item-mobile border-bottom py-3 d-block d-md-none">
        <div className="d-flex align-items-center gap-2">
          <img
            src={product.image}
            alt={product.title}
            className="product-img"
            style={{ width: "60px", height: "60px", objectFit: "cover" }}
          />
          <div className="flex-grow-1">
            <h6 className="mb-1">{product.title}</h6>
            <small className="text-muted">{product.ref}</small>
          </div>
          <Button
            variant="link"
            className="text-danger p-0"
            onClick={() => onRemove(product._id)}>
            <DelecteIcon />
          </Button>
        </div>

        <div className="mt-2">
          <div className="d-flex justify-content-between">
            <span>Prix unitaire:</span>
            <strong>{Number(product.price).toFixed(3)} dt</strong>
          </div>
          <div className="d-flex justify-content-between align-items-center mt-2">
            <span>Qté :</span>
            <input
              type="number"
              min="1"
              max={product.quantite}
              value={product.quantity}
              className="form-control qty-input w-25"
              onChange={handleQuantityChange}
            />
          </div>
          {error && <div className="error1 mt-1 text-danger">{error}</div>}
          <div className="d-flex justify-content-between mt-2">
            <span>Total :</span>
            <strong>{(product.price * product.quantity).toFixed(3)} dt</strong>
          </div>
        </div>
      </div>
    </>
  );
}
